<template>
	<v-flex xs12>
		<v-card>
			<v-card-title>
				<v-flex xs3>
					<v-toolbar-title>Feedback</v-toolbar-title>
				</v-flex>
				<v-flex xs6>
					<v-text-field
						v-model="search"
						append-icon="search"
						label="Search"
						single-line
						hide-details
					></v-text-field>
				</v-flex>
			</v-card-title>
			<v-data-table
				:headers="headers"
				:items="body"
				:search="search"
				:options.sync="options"
				:server-items-length="total"
				:loading="loading"
				:single-expand="true"
				show-expand
			>
				<template v-slot:expanded-item="{ headers, item }">
					<td :colspan="headers.length">{{ item.message }}</td>
				</template>
				<template v-slot:no-data>
					<v-alert :value="true">No results found.</v-alert>
				</template>
			</v-data-table>
		</v-card>
	</v-flex>
</template>

<script>
import commonservice from "../../shared/common.service";
export default {
	data() {
		return {
			search: "",
			loading: false,
			options: {},
			total: 0,
			headers: [
				{ text: "Name", value: "name" },
				{ text: "Email", value: "email" },
				{ text: "Subject", value: "subject", sortable: false },
				{ text: "Phone", value: "phone", sortable: false },
				{ text: "Created Date", value: "createdDate" },
			],
			body: [],
		};
	},
	watch: {
		options: {
			handler() {
				this.getData();
			},
			deep: true,
		},
		search() {
			this.getData();
		},
	},
	methods: {
		getData() {
			this.$store
				.dispatch("feedback/loadFeedback", {
					pagination: this.options,
					search: this.search,
				})
				.then((response) => {
					this.loading = false;
					this.body = response.data.data;
					this.total = response.data.total;
				})
				.catch(() => {
					this.loading = false;
				});
		},
	},
};
</script>
